import React, { FC } from 'react';
import { Heading, Text } from '@kl/components-v6';
import { CreateAccount } from 'features/create-account';
import { SignIn } from 'features/sign-in';
import { Locale } from 'shared/ui/locale';
import { StyledFlexContainer } from 'shared/ui/styled-components';
import {
    StyledSectionDescription,
    StyledSectionContainer,
    StyledSectionWrapper,
    StyledSubstrateContainer,
    StyledButtonContainer,
    StyledImage,
    StyledBackground,
} from './styled';

interface MainBannerProps {
    signUp: string;
    signIn: string;
    isKscMode: boolean;
}

export const MainBanner: FC<MainBannerProps> = ({ signUp, signIn, isKscMode }) => (
    <>
        <StyledBackground>
            <StyledImage />
        </StyledBackground>
        <StyledSubstrateContainer>
            <StyledSectionContainer>
                <StyledSectionWrapper $direction="column" $gap="16px">
                    <StyledFlexContainer $direction="column" $width="100%">
                        <Heading type="H2">
                            <Locale
                                localizationKey={
                                    isKscMode ? 'Landing.KscHeader' : 'Landing.NextHeader'
                                }
                            />
                        </Heading>
                        {isKscMode && (
                            <Heading type="H4">
                                <Locale localizationKey="Landing.KscSubHeader" />
                            </Heading>
                        )}
                    </StyledFlexContainer>
                    <StyledSectionDescription>
                        <Text type="BTM2">
                            <Locale
                                localizationKey={
                                    isKscMode ? 'Landing.KscDescription' : 'Landing.NextDescription'
                                }
                            />
                        </Text>
                    </StyledSectionDescription>
                    <StyledButtonContainer>
                        <SignIn signInUrl={signIn} testId="signIn" />
                        <CreateAccount signUpUrl={signUp} testId="signUp" />
                    </StyledButtonContainer>
                </StyledSectionWrapper>
            </StyledSectionContainer>
        </StyledSubstrateContainer>
    </>
);
